import { NumberishId } from "../../model/type";
import ApiClient from "../api/ApiClient";
import { Offer } from "../../model/Offer";
import { DateTime } from "luxon";
import { ApiOffer } from "../api/Endpoint/Offers_Id";
import { MediumFilterOptions } from "../../model/Medium";
import { OfferCreatorFilterOptions } from "../../view/page/offer-panel/offer-creator/common/Filters";

export default class OffersDao {
    private apiClient: ApiClient;

    constructor(apiClient: ApiClient) {
        this.apiClient = apiClient;
    }

    public find(offerId: NumberishId): Promise<Offer> {
        return this.apiClient.offers_Id.get(offerId)
            .then(response => response.data)
            .then((offer: ApiOffer) => ({
                ...offer,
                created: DateTime.fromISO(offer.created),
                startDate: DateTime.fromISO(offer.startDate),
                endDate: DateTime.fromISO(offer.endDate),
            }))
    }

    public getFilterOptions(offerId: NumberishId): Promise<OfferCreatorFilterOptions> {
        return this.apiClient.offers_Id_FilterOptions.get(offerId)
            .then(response => response.data)
    }
}